export class Line {
}

//# sourceMappingURL=Line.js.map
